import React from "react";

const ProductUnitSelect = ({ options, value, onChange }) => {
  if (!options || options.length <= 1) {
    return null;
  }

  return (
    <select
      className="product-unit-select"
      value={value}
      onClick={(event) => event.stopPropagation()}
      onChange={(event) => {
        event.stopPropagation();
        onChange(Number(event.target.value));
      }}
    >
      {options.map((option) => (
        <option key={option.unit_level} value={option.unit_level}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default ProductUnitSelect;
